import { initWindowResize, onWindowResize, currentBreakpoint, currentBreakpointIndex } from './utils/windowResize';
import { initScroll } from './utils/scroll';
import { onReady } from './utils/onReady';
import { setupNav } from './components/nav';
import { setupLazyLoading } from './utils/lazyImage';
import { setupAccordions } from './components/accordion';
import { setupVideos } from './components/video';
import { isTouch, initVhUnitOverwrite } from './utils/helpers';
import pkg from '../../package.json';
import { setupAnchorLinkScroll } from './components/anchors';
import { setupFilters } from './components/filter';
import { setupOverlay } from './components/overlay';
import { setupTabs } from './components/tabs';
import { setupEntrances } from './components/entrances';
import { setupImageToVideo } from './components/image-to-video';
import { setupNewslist } from './components/newslist';
import { setupGallery } from './components/gallery';
import { setupCalendarFilter } from './components/calendarFilter';
import { setupCalendarAccordion } from './components/calendarAccordion';
import { setupCalendar } from './components/calendar';

// Below are example of how to use import libraries installed via npm.
// import "intersection-observer"; // Polyfill used for sal.js animations
// import {sal} from "sal.js";

function init() {
    document.body.classList.remove('standby');
    document.body.setAttribute('data-is-touch',isTouch());

    setupAnchorLinkScroll();

    initWindowResize();

    initScroll();

    setupNav('.nav', false);

    onReady(() => {
        initVhUnitOverwrite();

        setupLazyLoading();

        setupAccordions();

        setupFilters();

        setupOverlay();

        setupVideos();

        setupTabs();

        setupEntrances();

        setupImageToVideo();

        setupNewslist();

        setupGallery();

        setupCalendarFilter();

        setupCalendarAccordion();

        setupCalendar();
    });

    // Simulated CookieBot function-call via GTM
    window.showCookieBanner('cookiebanner-2');
}

init();
